import { useState } from 'react';

export const useHelp = () => {
  const [showHelp, setShowHelp] = useState(false);

  // Toggle help tooltip
  const toggleHelp = (e) => {
    e.preventDefault();
    setShowHelp(!showHelp);
  };

  return {
    showHelp,
    setShowHelp,
    toggleHelp
  };
}; 